<template>
  <!-- 企业账号与安全 - 3 权限管理 -->
  <div class="module-Three">
    <!-- 筛选区 -->
    <el-form class="searchRegion" :inline="true" @submit.native.prevent>
      
      <div class="screen-end">
      <el-form-item :label="select == '1' ? '管理者：' : '申请者：'">
        <div class="size-search">
          <el-input
            v-model="input"
            :placeholder="select == '1' ? '请输入管理者姓名' : '请输入申请者姓名'"
          ></el-input>
        </div>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" class="ser-btn public-style" @click="handelSearch">搜 索</el-button>
        <el-button class="heavy-btn public-style" @click="handelReset">重 置</el-button>
      </el-form-item>
      </div>
    
    </el-form>
    <!-- 切换表格 -->
    <div class="Toggle">
      <div
        v-for="(item, index) in SelectArr"
        :key="index"
        class="toggle-item"
        :class="select == item.id ? 'select-p' : ''"
        @click="handelClick(item)"
      >
        {{ item.name }}
      </div>
    </div>
    <!-- 表格区 -->
    <div class="content">
      <ThreeTable1
        v-if="select == 1"
        :tableData="tableData"
        :HintMsg="HintMsg"
        @handleVerify="handleVerify"
      ></ThreeTable1>
      <ThreeTable2
        v-else
        :tableData="tableData1"
        :HintMsg="HintMsg1"
        @handleVerify="handleVerify"
      ></ThreeTable2>
    </div>

    <!-- 底部分页 -->
    <div class="paging-box">
      <div class="paging" v-if="select == '1'">
        <paging
          :pagingObj="pagingObj"
          @handleCurrentChange="handleCurrentChange"
        ></paging>
      </div>
      <div class="paging" v-else>
        <paging
          :pagingObj="conPagingObj"
          @handleCurrentChange="handleCurrentChange"
        ></paging>
      </div>
    </div>
  </div>
</template>

<script>
import {
  adminPermissions, //获取企业管理员权限列表
  bindAuditList, //获取企业申请加入的管理员审核列表
} from "../../../../../assets/api/firm/firmCenter";
// 引入表格1管理这表格
import ThreeTable1 from "./ThreeTable1.vue";
// 引入表格2申请表格
import ThreeTable2 from "./ThreeTable2.vue";
// 引入分页组件
import paging from "../../../../../components/paging.vue";
export default {
  data() {
    return {
      input: "",
      SelectArr: [
        {
          name: "管理者",
          id: "1",
        },
        {
          name: "审核",
          id: "2",
        },
      ],
      select: "1",
      pagingObj: {
        currentPage: 1, //当前页
        pageSize: 10, // 一页显示多少个
        totalDevice: 0, //用户总数
      }, // 列表分页
      conPagingObj: {
        currentPage: 1, //当前页
        pageSize: 10, // 一页显示多少个
        totalDevice: 0, //用户总数
      }, //分页数据
      tableData: [], // 管理者表格
      tableData1: [], // 申请表格
      HintMsg:'',//无数据/无权限提示语
      HintMsg1:'',//无数据/无权限提示语
    };
  },
  watch: {},
  components: { paging, ThreeTable1, ThreeTable2 },
  created() {
    // 未登录预览不打接口
    const user = this.$store.getters.getUser;
    if (!(user && user.id)) return;
    // 获取企业管理员权限列表
    this.adminPermissions();
    // 获取企业申请加入的管理员审核列表
    this.bindAuditList();
  },
  methods: {
    // 管理者/审核切换
    handelClick(item) {
      this.select = item.id;
      this.input = "";
      if (item.id == "1") {
        this.adminPermissions();
      } else {
        this.bindAuditList();
      }
    },
    //  成功后刷新页面数据
    handleVerify() {
      if (this.select == "1") {
        this.adminPermissions();
      } else {
        this.bindAuditList();
      }
    },
    // ------------------获取企业申请加入的管理员审核列表
    bindAuditList() {
      var data = {
        data: {
          companyId: this.$store.getters.getCompany.id, // 企业id
          name: this.input, // 查询参数
        },
      };
      bindAuditList(
        data,
        this.conPagingObj.currentPage,
        this.conPagingObj.pageSize
      ).then((res) => {
        if (res.code == 0) {
          this.tableData1 = res.data.list;
          this.conPagingObj.totalDevice = res.data.total;
        }else if(res.code == -513){
          this.HintMsg1 = '没有访问权限'
        }
      });
    },
    // --------------------------------------- 获取企业管理员权限列表
    adminPermissions() {
      var data = {
        data: {
          companyId: this.$store.getters.getCompany.id, // 企业id
          name: this.input, // 查询参数
        },
      };
      adminPermissions(
        data,
        this.pagingObj.currentPage,
        this.pagingObj.pageSize
      ).then((res) => {
        if (res.code == 0) {
          this.tableData = res.data.list;
          this.pagingObj.totalDevice = res.data.total;
        }else if(res.code == -513){
          this.HintMsg = '没有访问权限'
        }
      });
    },
    // 搜索
    handelSearch() {
      if (this.select == "1") {
        this.pagingObj = {
          currentPage: 1, //当前页
          pageSize: 10, // 一页显示多少个
          totalDevice: 0, //用户总数
        }; // 列表分页
        this.adminPermissions();
      } else {
        this.conPagingObj = {
          currentPage: 1, //当前页
          pageSize: 10, // 一页显示多少个
          totalDevice: 0, //用户总数
        }; //分页数据
        this.bindAuditList();
      }
    },
    // 重置
    handelReset() {
      this.input = "";
      if (this.select == "1") {
        this.pagingObj = {
          currentPage: 1, //当前页
          pageSize: 10, // 一页显示多少个
          totalDevice: 0, //用户总数
        }; // 列表分页
        this.adminPermissions();
      } else {
        this.conPagingObj = {
          currentPage: 1, //当前页
          pageSize: 10, // 一页显示多少个
          totalDevice: 0, //用户总数
        }; //分页数据
        this.bindAuditList();
      }
    },
    // 分页
    handleCurrentChange(val) {
      // 邀请列表分页
      if (this.select == "1") {
        this.pagingObj.currentPage = val;
        this.adminPermissions();
      } else {
        //被邀请人消费详情列表分页
        this.conPagingObj.currentPage = val;
        this.bindAuditList();
      }
    },
  },
};
</script>

<style scoped lang="less">
// 模块1 最外层
.module-Three {
  width: 100%;
  min-height: 50px;
}
// 搜索区域
.searchRegion {
  margin-top: 0;
  margin-bottom: 0;
  position: relative;
}
// 切换
.Toggle {
  width: 100%;
  height: 35px;
  margin-top: 30px;
  margin-bottom: 30px;
  display: flex;
  .toggle-item {
    width: 110px;
    height: 35px;
    line-height: 35px;
    text-align: center;
    background: #eeeeee;
    border-radius: 5px;
    font-family: PingFangSC-Medium;
    font-size: 12px;
    color: #666666;
    font-weight: 400;
    margin-right: 10px;
    cursor: pointer;
  }
  .toggle-item.select-p {
    color: #409eff;
    background: rgba(97, 144, 232, 0.2);
  }
}
// 表格
.content {
  width: 100%;
  min-height: 300px;
  box-sizing: border-box;
}
// 分页
.paging-box {
  width: 100%;
  height: 22px;
  margin-top: 30px;
  display: flex;
  justify-content: flex-end;
  .paging {
    width: 90%;
    height: 100%;
    display: flex;
    justify-content: flex-end;
  }
}
</style>
